import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDHeadlineText } from '@facet-wealth/design';

export const summaryOverrides = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => FDHeadlineText,
    _customProps: { size: 'lg', flex: 1 },
  }, overrideReadOnly)
  .done();
